export const DocumentIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 5.16634V11.833C14 13.833 13 15.1663 10.6667 15.1663H5.33333C3 15.1663 2 13.833 2 11.833V5.16634C2 3.16634 3 1.83301 5.33333 1.83301H10.6667C13 1.83301 14 3.16634 14 5.16634Z"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.66663 3.5V4.83333C9.66663 5.56667 10.2666 6.16667 11 6.16667H12.3333"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33337 9.16699H8.00004"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33337 11.833H10.6667"
        stroke="#010D1D"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
